export default __webpack_public_path__ + "static/media/i086vp.748f96db.webp";